import { ProgCss } from "./ProgCss.Generated";
import { cast } from "./tools";

declare global { interface Window { ShowAfletterenContextMenuForTest: Function; } }

function InitAfletterenMutatieRijElement(afletterenMutatierijElement: Element) {
    afletterenMutatierijElement.addEventListener("mouseup", e => AfletterDetailOnSelect(cast(e, MouseEvent)));

    const zoekMenuElement = cast(afletterenMutatierijElement.querySelector(`.${ProgCss.afletterenZoekMenu}`), HTMLElement);
    const afletterenZoekTekstElement = zoekMenuElement.querySelector(`.${ProgCss.afletterenZoekTekst}`);
    const afletterenZoekTekstInput = zoekMenuElement.querySelector("input");
    for (const b of zoekMenuElement.querySelectorAll(`.${ProgCss.afletterenZoekMenu_Button}`)) {
        // De tabindex is nodig om de blur af te laten gaan
        b.setAttribute("tabindex", "1");
    }
    // De tabindex is nodig om de blur af te laten gaan
    zoekMenuElement.setAttribute("tabindex", "1");

    zoekMenuElement.addEventListener("blur", AfletterenZoekMenuBlur, true);

    function AfletterenZoekMenuBlur(e: FocusEvent) {
        if (!e.relatedTarget || !zoekMenuElement.contains(cast(e.relatedTarget, Node))) {
            // Kleine timeout voor IE om te voorkomen dat het zoekvenster verdwenen is voordat de submit wordt uitgevoerd.
            setTimeout(
                function () {
                    zoekMenuElement.style.display = "none";
                },
                100);
        }
    }

    function ShowMenu(offsetLeft: Number, offsetTop: Number, selectionText: string) {
        zoekMenuElement.style.left = offsetLeft + "px";
        zoekMenuElement.style.top = offsetTop + "px";
        zoekMenuElement.style.display = "block";
        zoekMenuElement.focus();

        afletterenZoekTekstElement!.textContent = selectionText;
        afletterenZoekTekstInput!.value = selectionText;
    }

    window.ShowAfletterenContextMenuForTest = ShowMenu;

    function AfletterDetailOnSelect(e: MouseEvent) {
        if (!(e.target instanceof Element)) {
            throw new Error(`Expected child event target within AfletterDetailOnSelect to be an element, but got ${e.target && e.target.constructor}.`);
        }
        if (zoekMenuElement.contains(e.target)) {
            return;
        }
        const selectionText = ValidatedSelection();
        if (selectionText) {

            const offset = zoekMenuElement.parentElement!.getBoundingClientRect();
            const clientRects = e.target.getClientRects();
            const y = Math.max(clientRects[clientRects.length - 1].bottom, e.clientY);

            ShowMenu(e.clientX - offset.left + 10, y - offset.top + 10, selectionText);
        }

        function ValidatedSelection() {
            const selection = getSelection();
            const text = selection!.toString();
            // selection.anchorNode is in Edge bij het laatste woord in het element een textnode en niet de containing span.
            // Daarom  checken op zowel selection.anchorNode als selection.anchorNode.parentElement
            const selectionStartsEndEndsInSameNode = selection!.anchorNode === selection!.focusNode || selection!.anchorNode!.parentElement === selection!.focusNode;
            return selectionStartsEndEndsInSameNode ? text : null;
        }
    };
}

export function Afletteren(scopeEl: HTMLElement) {
    for (const afletterenMutatieRijElement of scopeEl.getElementsByClassName(ProgCss.js_afletterenMutatierij)) {
        InitAfletterenMutatieRijElement(afletterenMutatieRijElement);
    }
}
